import { render, staticRenderFns } from "./TwoFactorPage.vue?vue&type=template&id=73603140&scoped=true"
import script from "./TwoFactorPage.vue?vue&type=script&lang=js"
export * from "./TwoFactorPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73603140",
  null
  
)

export default component.exports